import {axios, HOST, config} from './settiing';

export default {
    getReceptionListForDriving(params) {
        config.params = params;
        const result = axios.get(`${HOST}/manage/receipt/drive/${params.date}`, config);
        config.params = null;
        return result;
    },
    getReceptionListForDelivery(params) {
        config.params = params;
        const result = axios.get(`${HOST}/manage/receipt/delivery/${params.date}`, config);
        config.params = null;
        return result;
    },
    getReceptionExcelData(params) {
        return axios.get(`${HOST}/manage/receipt/download/${params.date}`, config);
    }
}